export default __webpack_public_path__ + "static/media/TXUI_Ramp_Corner_8x2.256.147fe6a2.png";